import React, { useEffect, useState } from "react";
import { useSearch } from "../../Hooks";
import Loading from "../../../../Common/Loading";
import { useSelector } from "react-redux";
import { Spinner } from "react-bootstrap";

const Search = ({ handleFilter, getValue, loading, filterDelete }) => {
  const { getCategory, data, loadingSearch } = useSearch();
  const { categories, cities } = useSelector(state => state);

  useEffect(() => {
    if (!categories) {
      getCategory();
    }
  }, []);
  if (!categories) {
    return (
      <div className="new-box-shadow search-box">
        <Loading count={1} height={"70"} />
      </div>
    );
  }
  return (
    <div
      style={
        {
          // width: "70%",
          // height: "70px",
          // position: "absolute",
          // left: 0,
          // right: 0,
          // marginLeft: "auto",
          // marginRight: "auto",
          // zIndex: 120,
          // top: "-22px",
          // display: "flex",
          // backgroundColor: "#fff",
          // alignItems: "center",
          // borderRadius: "8px",
          // overflow: "hidden",
        }
      }
      className="search-box"
    >
      <div
        className="container"
        style={{
          height: "100%",
        }}
      >
        <div
          className="row"
          style={{
            height: "100%",
          }}
        >
          <div className="col-12 col-lg-2">
            <select
              disabled
              style={{
                backgroundColor: "transparent",
                border: "none",
                width: "100%",
                height: "100%",
                color: "#959595",
              }}
            >
              <option>کلاس های ورزشی</option>
            </select>
          </div>
          <div className="col-lg-3">
            <select
              style={{
                backgroundColor: "transparent",
                border: "none",
                width: "100%",
                height: "100%",
                color: "#959595",
              }}
              onChange={({ target: { value } }) => {
                if (value == "all") {
                  filterDelete("city_id");
                } else {
                  handleFilter("city_id", value);
                }
              }}
              value={getValue("city_id")}
            >
              <option value={"all"}>همه شهر ها</option>

              {cities &&
                cities.map(city => {
                  return (
                    <option
                      selected={getValue("city_id") == city.id}
                      value={city.id}
                    >
                      {city.name}
                    </option>
                  );
                })}
            </select>
          </div>
          <div className="col-lg-3">
            <input
              style={{
                backgroundColor: "transparent",
                borderColor: "transparent",
                height: "100%",
                color: "#959595",
              }}
              placeholder="همه کلاس های ورزشی"
              onChange={({ target: { value } }) => {
                if (value.length % 2 === 0) {
                  handleFilter("name", value);
                }
              }}
              checked={getValue("name")}
            />
          </div>
          <div className="col-lg-4 p-0">
            <button
              style={{
                border: "none",
                backgroundColor: "transparent",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                backgroundColor: "#E42A3F",
                color: "#fff",
                height: "100%",
                width: "100%",
                height: "100%",
                fontSize: "20px",
                color: "#fff",
              }}
              disabled={loading}
            >
              {loading ? (
                <Spinner
                  as="span"
                  animation="border"
                  size="lg"
                  role="status"
                  aria-hidden="true"
                />
              ) : (
                <>
                  <img
                    src={window.origin + "/WebSide/assets/images/zoom.png"}
                    alt="امتیاز"
                    style={{
                      width: "20px",
                      height: "20px",
                    }}
                  />
                  جست و جو
                </>
              )}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Search;
